export const environment = {
  firebase: {
    apiKey: "AIzaSyBUPbasPE8u3K8ILHKsgLibTftxG0bAkuA",
    authDomain: "beeasy-ai.firebaseapp.com",
    projectId: "beeasy-ai",
    storageBucket: "beeasy-ai.firebasestorage.app",
    messagingSenderId: "762910320646",
    appId: "1:762910320646:web:f61d84a2f14707edddfb87",
    measurementId: "G-06CG3QVQQ0"
  },
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyBUPbasPE8u3K8ILHKsgLibTftxG0bAkuA",
    authDomain: "beeasy-ai.firebaseapp.com",
    projectId: "beeasy-ai",
    storageBucket: "beeasy-ai.firebasestorage.app",
    messagingSenderId: "762910320646",
    appId: "1:762910320646:web:f61d84a2f14707edddfb87",
    measurementId: "G-06CG3QVQQ0"
  },
};

